export var ContentTreeTemplateMutationtypes;
(function (ContentTreeTemplateMutationtypes) {
    ContentTreeTemplateMutationtypes["INIT_STATE"] = "INIT_STATE";
    ContentTreeTemplateMutationtypes["FETCH_CONTENT_TREE_TEMPLATES"] = "FETCH_CONTENT_TREE_TEMPLATES";
    ContentTreeTemplateMutationtypes["CREATE_CONTENT_TREE_TEMPLATE"] = "CREATE_CONTENT_TREE_TEMPLATE";
    ContentTreeTemplateMutationtypes["UPDATE_CONTENT_TREE_TEMPLATE"] = "UPDATE_CONTENT_TREE_TEMPLATE";
    ContentTreeTemplateMutationtypes["DELETE_CONTENT_TREE_TEMPLATE"] = "DELETE_CONTENT_TREE_TEMPLATE";
})(ContentTreeTemplateMutationtypes || (ContentTreeTemplateMutationtypes = {}));
